<template>

<div  class="container-fluid" >
  


  <div  v-if="type=='A'"  class="card">
  
    <div class="card-header bg-primary text-white">    
        <h4><i style="color:yellow" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
       MAGAZZINO / RICERCA PRODOTTI
           </h4>    
    </div>
    
  
    <div class="card-body "> 

    <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    <div class="card border-info mb-2">
    <div class="card-header bg-info text-white">
      <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
      <strong>PARAMETRI DI RICERCA</strong>
  
    </div>

    <div class="card-body text-dark">

    <form name="productSearch" v-on:submit.prevent="getData()">
    <div v-if="params" class="form-row_">
     
      <inputSearch @update="setData" v-bind:inputId="input.id"></inputSearch>   

    </div>
    

    <div v-else>
    
    <div class="form-row">     
      <div class="form-group col-md-6">                
        <supplier-select  v-bind:optionBase="true"  v-bind:Id="0" v-bind:isActive="true" @update="setSupplierId"></supplier-select>
      </div>
      <div class="form-group col-md-6">                
        <brand-list v-bind:props="brand" @update="setBrandId"></brand-list>
      </div>
    </div>
    <div class="form-row">   
        <!-- GROUP CATEGORY -->
        <div class="form-group col-md-6">
            <category-grouping v-bind:optionBase="true" v-bind:isActive="true" @update="setGroupCategoryId"></category-grouping>  
        </div>
     

        
        <div class="form-group col-md-6">
            <category-select v-bind:optionBase="true" v-bind:isActive="true" @update="setCategoryId"></category-select>  
        </div>

    </div>    

        <div class="form-row">
        <div class="form-group col-md-4">
            <department-select  v-bind:Id="0" v-bind:type="true" v-bind:optionBase="true" v-bind:isActive="true" @update="setDepartmentId"></department-select>  
        </div>



        <div class="form-group col-md-4">
            <season-select v-bind:Id="0" v-bind:type="true" v-bind:optionBase="true" v-bind:isActive="true" @update="setSeasonId"></season-select>      
        </div>



        <div class="form-group col-md-4">
         <year-select  v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYear"></year-select>      
        </div> 


        </div>
        </div>
      <div class="card-footer bg-transparent border-info">

       <div class="row">   
       <div class="col"> 
        
        <button :disabled="spinner"  class="btn btn-primary mr-3">
       <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      CERCA
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-2 text-warning" role="status" aria-hidden="true"></span>
      </button>


       <button  type="button" @click="product={},params = !params,msg.title=''" class="btn btn-secondary text-nowrap text-left">
       <i style="color:yellow" class="	fas fa-sync-alt mr-2" aria-hidden="true"></i>
       CAMBIA PARAMETRI DI RICERCA
      
      </button> 
      
      </div>
       
     
      </div>

      </div>

  </form>

  </div>
  </div>
  </div> 
  </div>



  <div v-else-if="type=='B'"  class="card ">
    <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
    <div class="card-header bg-primary text-white">    
        <h4><i style="color:#FFD700"  class="fas fa-table mr-2" aria-hidden="true"></i>
       BACK OFFICE/LISTA PRODOTTI
           </h4>    
    </div> 

      <div class="card-body">
        <button  type="button" @click="type='A', items=[],product={} " class="btn btn-secondary btn-block mb-1 ">
       <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
        RITORNA A PARAMETRI RICERCA
        </button>   
      
      

      <div class="table-wrapper-scroll-y my-custom-scrollbar ml-1 mr-1">

      <table class="table table-hover table-sm table-bordered table-striped mb-0">
      <thead >
      <tr class="table-primary">
    <th scope="col">#</th>
    <th scope="col">
      <i  class="fas fa-globe " aria-hidden="true"></i>

    </th>
    <th scope="col">
      <i  class="fas fa-bell-slash" aria-hidden="true"></i>

    </th>
    <th v-if="company.shopify" class="text-right_" scope="col"></th>                  
    <th scope="col">ID PRODOTTO</th>
    <th scope="col">BRAND</th>
    <th scope="col">LINEA</th>
     <th scope="col">CODICE</th>                
    <th scope="col">CATEGORIA</th>
    <th scope="col">DESCRIZIONE</th>
    
    <th scope="col">REPARTO</th>
    <th scope="col">STAGIONE</th>
    <th class="text-right" scope="col">LISTINO</th>     
    
  </tr>
</thead>
<tbody>
  
  <tr data-toggle="tooltip" title="Doppio click seleziona prodotto" class="pointer" v-on:dblclick="setProduct(item)"  v-for="(item, index) in filteredProducts" :key="index">
    <td
    
    >{{index+1}}</td>

     <td> <span :class="{dotRed:item.mp_count > 0}"></span></td>
     <td> <span :class="{dotGreen:item.NoPromo > 0}"></span></td> 

     <td v-if="company.shopify">
      <button :disabled="shopifySpinner" data-toggle="tooltip" title="Sicronizza varianti prodotto."  type="button" @click="syncShopify(item.productId)" class="btn btn-success">
       <i style="color:black" class="fas fa-sync mr-2" aria-hidden="true"></i>
        Sync SHOPIFY

        </button>   
      
    </td> 

    <td>{{item.productId}}</td>

    <td class="text-nowrap">{{item.brand}}</td>
    <td class="text-nowrap">{{item.line}}</td>
    <td class="text-nowrap"><strong>{{item.sku}}</strong></td>        
    <td>{{item.category}}</td>
    <td class="text-nowrap">{{item.description}}</td>
    
    <td>{{item.department}}</td>
    <td class="text-nowrap">{{item.season}}-{{item.season_year}} </td>      
    <td class="text-right">{{fmt1(item.priceList)}}</td>
    
    
  </tr> 
  
  
</tbody>

</table>


</div>

</div>



<filter-key @update="setFilterKey"/>  





</div>

<!-- CARD BODY -->

<div v-if="type=='C'">
  <tab @refreshProductList="refresh" @close="type = 'B',product={}" v-bind:product="item" ></tab> 
</div>  


<!-- CONTAINER-->
</div>



</template>

<script>

import api             from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'
//import spinner           from './../../components/common/Spinner.vue';
import supplierSelect    from '@/components/common/SupplierSelect.vue';
import categoryGrouping  from '@/components/common/CategoryGroupingSelect.vue';
import categorySelect    from '@/components/common/CategorySelect.vue';
import departmentSelect  from '@/components/common/DepartmentSelect.vue';
import seasonSelect      from '@/components/common/SeasonSelect.vue';
import yearSelect        from '@/components/common/YearSelect.vue';
import tab               from '@/components/backOffice/ready/tab/ProductTab.vue'
import filterKey         from '@/components/common/FilterKey.vue'
import brandList         from '@/components/common/CompanyBrandSelect_1.vue'
import pushState         from '@/components/mixins/pushState'
import inputSearch       from '@/components/frontOffice/InputSearch.vue'
import fmt               from '@/components/mixins/fmt'
import modalSpinner      from '@/components/common/ModalSpinner.vue'

import {mapGetters }    from 'vuex';
export default {
   //props      : ['route'],
  mixins : [pushState,fmt],
   components  : {alertBox,supplierSelect,categoryGrouping,categorySelect,departmentSelect,seasonSelect,yearSelect,tab,filterKey,brandList,inputSearch,modalSpinner},
  data() {
    return {
      modalSpinner : {spinner:false,show:false},
      brand           :
      {
        Id            : '',
        required      : false,

      },
      product                : {},
     
      items                  : [],
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      spinner                : false,     
      
      total                  : 0,
      type                   : 'A',
      item                   : {},
      params                 : true,
      filterKey              : '',
      input                      : 
      {
        
          id                     : 0,
          search                 : '',
      },
      
      shopifySpinner         : false
    
     
    }
  },
  computed :{
   
     ...mapGetters(['company','storeId']),
      filteredProducts : function () 
      {
        
        
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) 
        {
            items = items.filter(function (row) 
            {
                return Object.keys(row).some(function (key) {
                return String(row[key]).toLowerCase().indexOf(filterKey) > -1
              })
            })
        }
        return items

     }, 


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {
    
    
    
  },
  created: function() {
    
    

  },
  methods: {
    
    setModalSpinner(show)
      {
        
        this.modalSpinner.show = show
        
      },
   async syncShopify(productId)
    {
      

      this.modalSpinner.show    = true
      this.modalSpinner.spinner = true
      this.modalSpinner.title   = 'Sincronizzazione in corso ...'
      
      
      const response = await api.shopifyCreateProductVariants(this.company.Id,productId)
      console.log(response)

      
      this.modalSpinner.spinner = false
      this.modalSpinner.msg   = response
      
    },
    setData(data,id)
    {
      this.input.id = id
      this.input.search = data
      
    },
    setBrandId(brandId)
    {

      this.product.Brand = brandId
          

    },
    refresh(msg)
    {
     
      this.filteredProducts.forEach(item => {
        if(item.productId == msg.productId )
        {
          
            item.mp_count = msg.productInMP ? 0: 1
          
        }
        
      });
    },
    setFilterKey(value)
    {
        this.filterKey = value
    },

 

    setProduct(item)
    {
        
        /* PASSA STORE ID A TAB */
        item.storeId = this.storeId
        this.item = item
        this.type = 'C'

        
        
    },
    setSupplierId(Id)
    {
      
        this.product.SupplierId = Number(Id)
    },
    setGroupCategoryId(Id)
    {
      
        this.product.GroupCategoryId = Number(Id)
    },
    setCategoryId(Id)
    {
      
        this.product.CategoryId = Number(Id)
    },
    setDepartmentId(Id)
    {
      
        this.product.DepartmentId = Number(Id)
    },
    setSeasonId(Id)
    {
      
        this.product.SeasonId = Number(Id)
    },
    setYear(year)
    {
        this.product.SeasonYear = Number(year)
    },

    async getData() {

      this.msg.title = ''
      let counter = 0
      for (const [key, value] of Object.entries(this.product)) 
      {
          if(key && value )
          { ++counter }
          
      }
      
      if(!this.params && counter < 3)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = 'SELEZIONARE ALMENO 3 PARAMETRI DI RICERCA.'
        this.msg.type  = 1
        return
      }

      if(this.input.id == 0 && this.input.search.length < 3 && this.params)
      {
        this.msg.title = 'ATTENZIONE'              
        this.msg.body  = 'DIGITARE ALMENO 3 CARATTERI.'
        this.msg.type  = 1
        
        return
      }

      this.items = []  
          
      this.filterKey = ''
      this.total     = 0
      this.spinner   = true
    
      const data     = {

      'companyId'     : this.company.Id,      
      
      
      'productKey'    : this.params ? this.input.id :  -1,
      'productSearch' : this.input.search.replace("'","").replace(/%/g,""),
      
      
    
      'seasonId'     : this.product.SeasonId,
      'departmentId' : this.product.DepartmentId,
      'year'         : this.product.SeasonYear,      
      'categoryId'   : this.product.CategoryId,
      'grpcategory'  : this.product.GroupCategoryId,
      'supplierId'   : this.product.SupplierId,
      'brand'        : this.product.Brand,
    
      } 
      
  
      const sp = {'sp':'spNewProductSearch'}
      const json    = Object.assign(data, sp)
      

         await api.post(json).then(res => {
        
          if(res.status==200)
            {
             
              this.items     = res.data.recordsets[0]
             
              if(res.data.recordsets[0].length==0)
              { 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }
              else
              {
                this.type = 'B'
              }

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.spinner = false
      


    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
  position: relative;
  height: 600px;
  overflow: auto;
}
.pointer:hover
{
  background-color  : rgb(31, 28, 236);
  color             : white;
  cursor            : pointer;
}
.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;

    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2;


    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}
.dotRed
{
  height: 10px;
  width: 10px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
.dotGreen
{
  height: 10px;
  width: 10px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: green;
}
.card-header
{
  height: 45px;
}
</style>